export default {"src":"/_next/static/media/google-icon.a6bc4db3.svg","height":512,"width":488,"blurWidth":0,"blurHeight":0};